export class FunctionalityInDataGrid {
    id: string;
    description: string;
    order: number;
    deleting: FunctionalityAbilityAsCheckbox;
    editing: FunctionalityAbilityAsCheckbox;
    reading: FunctionalityAbilityAsCheckbox;
}

export class FunctionalitiesModel {
    IsEliminaVisibile: boolean;
    Id: string;
    Ordinamento: number;
    OggettoDescr: string;
}

type FunctionalityAbilityAsCheckbox = {
    disabled: boolean;
    label: string;
    readonly: boolean;
    value: boolean;
    visible: boolean;
};
